import React, { useEffect, useState } from "react";
import { Tabs, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { IconUsersGroup, IconClipboardCheck, IconChartTreemap, IconSettings, IconChevronLeft } from "@tabler/icons-react";
import { Link, useLocation } from "react-router-dom";
import { getDepartments, userWiseRight } from "../../services/dataService";

export default function Sidebar() {
  const UID = localStorage.getItem("userId");
  const [department, setDepartment] = useState([]);
  const [mastersChildren, setMastersChildren] = useState([]);
  const [TranscationsChildren, setTranscationsChildren] = useState([]);
  const [ReportChildren, setReportChildren] = useState([]);
  const [SettingsChildren, setSettingsChildren] = useState([]);
  const location = useLocation();
  const urlPath = location.pathname || '/';
  const [menuItem, setMenuItem] = useState(null);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await getDepartments(UID);
        setDepartment(response.data.data);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchDepartment();
  }, []);

  useEffect(() => {
    const master = async () => {
      try {
        const response = await userWiseRight(UID);
        const masters = response?.data?.data?.filter((el) => el.Category === 'Masters');
        setMastersChildren(masters);
      } catch (error) {
        console.log(error, "err");
      }
    };
    master();
  }, []);

  useEffect(() => {
    const Transactions = async () => {
      try {
        const response = await userWiseRight(UID);
        const Transactions = response?.data?.data?.filter((el) => el.Category === 'Transactions');
        setTranscationsChildren(Transactions);
      } catch (error) {
        console.log(error, "err");
      }
    };
    Transactions();
  }, []);

  useEffect(() => {
    const Reports = async () => {
      try {
        const response = await userWiseRight(UID);
        const Reportss = response?.data?.data?.filter((el) => el.Category === 'Reports');
        setReportChildren(Reportss);
      } catch (error) {
        console.log(error, "err");
      }
    };
    Reports();
  }, []);

  useEffect(() => {
    const Settings = async () => {
      try {
        const response = await userWiseRight(UID);
        const Settingss = response?.data?.data?.filter((el) => el.Category === 'Settings');
        setSettingsChildren(Settingss);
      } catch (error) {
        console.log(error, "err");
      }
    };
    Settings();
  }, []);

  const depIds = localStorage.getItem("DepartmentId")?.split(",");
  const firstDepId = depIds?.[0];
  const depName = department.find(el => el.Id == firstDepId)?.Name;

  if (depName) {
    localStorage.setItem('DepartmentName', depName);
  }

  const menuItemButton = (key) => {
    setMenuItem(menuItem === key ? null : key);
  };

  const menuItemLink = [
    {
      icon: IconUsersGroup,
      url: "Masters",
      hrMenu: true,
      children: mastersChildren.map((item) => ({
        url: item.Name,
        link: item.Router,
      })),
    },
    {
      icon: IconClipboardCheck,
      url: "Transactions",
      hrMenu: true,
      children: TranscationsChildren.map((item) => ({
        url: item.Name,
        link: item.Router,
      })),
    },
    {
      icon: IconChartTreemap,
      url: "Reports",
      hrMenu: true,
      children: ReportChildren.map((item) => ({
        url: item.Name,
        link: item.Router,
      })),
    },
    {
      icon: IconSettings,
      url: "Settings",
      hrMenu: true,
      children: SettingsChildren.map((item) => ({
        url: item.Name,
        link: item.Router,
      })),
    },
  ];

  return (
    <>
      <div className="p-20 border-b border-b-border pb-5">
        <div className="text-center mt-2">
          <span className="text-xl">{depName}</span>
        </div>
        {depIds && depIds.length > 1 && (
          <div className="flex flex-col gap-5 mt-4 px-4">
            <select
              onChange={(e) => {
                const selectedDeptId = e.target.value;
                if (!selectedDeptId) return;
                const currentDeptIds = localStorage.getItem("DepartmentId")?.split(",") || [];
                const newDeptIds = [
                  selectedDeptId,
                  ...currentDeptIds?.filter((id) => id !== selectedDeptId),
                ];
                localStorage.setItem("DepartmentId", newDeptIds.join(","));
                window.location.reload();
              }}
              className="bg-bg-dark border border-border rounded p-2 text-sm"
            >
              <option value="" selected>Change Department</option>
              {department
                ?.filter((dept) => depIds?.includes(dept.Id.toString()))
                ?.map((dept) => (
                  <option key={dept.Id} value={dept.Id}>
                    {dept.Name}
                  </option>
                ))}
            </select>
          </div>
        )}
      </div>
      <Tabs>
        <TabPanel>
          <ul className="py-15 flex flex-col gap-5">
            {menuItemLink.map(
              (item, key) =>
                item.hrMenu && (
                  <li key={key} className="pb-5">
                    <button
                      aria-label="menu item"
                      onClick={() => menuItemButton(key)}
                      className="w-full gap-5 menu-item flex items-center justify-between gap-5 px-15 py-13 transition-all duration-300 ease-in-out hover:bg-bg-light-100"
                    >
                      <span className="menu-icon flex items-center gap-20 text-[16px]/[20px] text-text-primary">
                        <item.icon className="min-w-[22px] min-h-[22px] w-[22px] h-[22px] stroke-[1.5] text-primary" />
                        <span>{item.url}</span>
                      </span>
                      <span className={`transition-all duration-300 ease-in-out ${menuItem === key ? "-rotate-90" : ""}`}>
                        <IconChevronLeft className="stroke-[1] text-text-secondary" />
                      </span>
                    </button>
                    {menuItem === key && (
                      <ul className="flex flex-col gap-5 overflow-auto cus-scrollbar">
                        {item.children.map((res, key) => (
                          <li key={key}>
                            <Link
                              to={res.link}
                              className={`pl-[57px] pr-15 py-10 block relative text-text-secondary h-40 before:content-["--"] before:absolute before:left-20 before:top-[50%] before:translate-y-[-50%] transition-all duration-300 ease-in-out hover:bg-bg-light-100 ${urlPath === res.link ? "font-bold" : ""}`}
                            >
                              <span>{res.url}</span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                )
            )}
          </ul>
        </TabPanel>
      </Tabs>
    </>
  );
}